import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import AuditLog from "@/views/module/auditLog/AuditLog.vue";

export default [
  {
    path: "/administration/audit-log",
    redirect: "/audit-log",
  },
  {
    path: "/audit-log",
    component: LayoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Audit Log",
    },
    children: [
      {
        path: "",
        name: "audit-log",
        component: AuditLog,
        meta: {
          breadcrumb: ["Audit & Compliance", "Activity Logs"],
        },
      },
    ],
  },
];
